import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export type StructureCode = 'cygnature' | 'suivez_vos_reves';
export type StructureFilter = 'all' | StructureCode;

export const STRUCTURE_LABELS: Record<StructureCode, string> = {
  cygnature: 'Cygnature Production',
  suivez_vos_reves: 'Suivez Vos Rêves Event',
};
export const STRUCTURE_SHORT: Record<StructureCode, string> = {
  cygnature: 'CYG',
  suivez_vos_reves: 'SVR',
};
export const STRUCTURE_COLORS: Record<StructureCode, string> = {
  cygnature: 'bg-amber-500/15 text-amber-300 border-amber-500/30',
  suivez_vos_reves: 'bg-violet-500/15 text-violet-300 border-violet-500/30',
};

interface Ctx {
  filter: StructureFilter;
  setFilter: (f: StructureFilter) => void;
  matches: (s: StructureCode | null | undefined) => boolean;
}

const StructureContext = createContext<Ctx | null>(null);

export function StructureProvider({ children }: { children: ReactNode }) {
  const [filter, setFilterState] = useState<StructureFilter>(() => {
    if (typeof window === 'undefined') return 'all';
    return (localStorage.getItem('crm-structure-filter') as StructureFilter) || 'all';
  });

  useEffect(() => {
    localStorage.setItem('crm-structure-filter', filter);
  }, [filter]);

  const setFilter = (f: StructureFilter) => setFilterState(f);
  const matches = (s: StructureCode | null | undefined) => {
    if (filter === 'all') return true;
    return (s || 'cygnature') === filter;
  };

  return (
    <StructureContext.Provider value={{ filter, setFilter, matches }}>
      {children}
    </StructureContext.Provider>
  );
}

export function useStructureFilter(): Ctx {
  const ctx = useContext(StructureContext);
  if (!ctx) throw new Error('useStructureFilter must be used inside StructureProvider');
  return ctx;
}
